import { GetSurveysByTimeResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetSurveysByTimeResponse } from '@/types/Psychosocial';

export class GetSurveysByTimeMapper {
	constructor(private readonly data: GetSurveysByTimeResponseDTO) {}

	toDomain(): GetSurveysByTimeResponse {
		return this.data;
	}
}
